import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { Processing } from '../components/processing';

interface ProviderValue {
    isLoading: boolean,
    setIsLoading: (value: boolean) => void,
}

export const LoadingContext = createContext<ProviderValue>({
    isLoading: false,
    setIsLoading: (_: boolean) => { }
});

export function LoadingProvider({ children }: { children: ReactNode }) {
    const [isLoading, setIsLoading] = useState(false);

    const value: ProviderValue = useMemo(() => ({ isLoading, setIsLoading }), [isLoading]);

    return (
        <LoadingContext.Provider value={value}>
            <Processing isLoading={isLoading} />
            {children}
        </LoadingContext.Provider>
    )
}

export const useLoading = () => useContext(LoadingContext);